import classNames from "classnames";
import { FormCheckbox, FormHelperText } from "components/form-fields";
import { ListingTable } from "components/listing";
import { HelperFunctions } from "helpers";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const defaultUserRoles = ["Role 1", "Role 2"];

export function TemplateRolePermissions(
    {
        isReadOnly = false,
        isNew = true,
        userRoles = defaultUserRoles,
        onChange,
        onValidationChange,
        template
    }
) {

    const [tableHeaders, setTableHeaders] = useState([]);
    const [tableRows, setTableRows] = useState([]);

    useEffect(() => {
        const newTableRow = [<span key="first-column">Complete this check</span>];
        
        for (const role of userRoles) {
            newTableRow.push(
                <FormCheckbox
                    key={role.id}
                    checked={isRoleSelected(role.id)}
                    onChange={() => onRoleChange(role.id)}
                />
            );
        };

        setTableRows([newTableRow]);
    }, [template.rolesWhoCanCompleteChecks, userRoles]);

    useEffect(() => {
        // No validation needed for this page
        onValidationChange(true);
    }, [])

    useEffect(() => {
        const newTableHeaders = ["Action"];
        
        for (const role of userRoles) {
            newTableHeaders.push(role.name);
        };

        setTableHeaders(newTableHeaders);
    }, [userRoles]);

    function isRoleSelected(role) {
        return template.rolesWhoCanCompleteChecks.includes(role);
    }

    function onRoleChange(role) {  
        const clonedTemplate = HelperFunctions.deepClone(template);

        if (clonedTemplate.rolesWhoCanCompleteChecks.includes(role)) {
            clonedTemplate.rolesWhoCanCompleteChecks = clonedTemplate.rolesWhoCanCompleteChecks.filter(r => r !== role);
        } else {
            clonedTemplate.rolesWhoCanCompleteChecks.push(role);
        }

        onChange(clonedTemplate);
    }

    return (
        <div className={classNames({ "row": !isNew })}>
            <h2>Role Permissions</h2>
            <div className="form-group">
                <h4
                    className="spacer-top spacer-bottom-small"
                >
                    Select which roles can complete this check
                </h4>
                <FormHelperText>If no roles are selected, all users will be able to complete checks for this template.</FormHelperText>
                <div className="spacer-bottom">
                    <ListingTable
                        pageable={false}
                        headers={tableHeaders}
                        data={tableRows}
                        loadingData={false}
                        totalRecordCount={tableRows.length}
                    />
                </div>
            </div>
        </div>
    );
}

TemplateRolePermissions.propTypes = {
    template: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    saving: PropTypes.bool.isRequired,
    onValidationChange: PropTypes.func.isRequired,
    isReadOnly: PropTypes.bool,
    isNew: PropTypes.bool,
    userRoles: PropTypes.array
};